import Vue from 'vue';
import $ from 'jquery';
import axios from 'axios';

Vue.component('roombooking', {
    props: {
        maxAdults: {
            type: Number,
            required: true,
            default: 2
        },
        defaultAdults: {
            type: Number,
            required: false,
            default: 2
        },
        maxChildren: {
            type: Number,
            required: true,
            default: 2
        },
        defaultChildren: {
            type: Number,
            required: false,
            default: 0
        },
        maxRooms: {
            type: Number,
            required: true,
            default: 4
        },
        maxCapacity: {
            type: Number,
            required: true,
            default: 3
        }
    },
    data: function () {
        return {
            totalAdults: 0,
            totalChildren: 0,
            totalPeople: [],
            showMaxRoomsInfo: false,
            showMaxPeopleInfo: false,
            disabledButton: false,
            totalRooms: 1,
            date: null,
            defaultText: null,
            startDate: null,
            endDate: null,
            altHeading: false,
            rooms: [{
                adult: this.defaultAdults,
                children: this.defaultChildren
            }],
            IBEUrlData: [{
                checkInDate: null,
                checkOutDate: null,
                promoCode: null,
                rateCode: null,
                roomCode: null,
            }],
            isPromoCodeOpen: false,
        };
    },

    mounted: function () {
        var thisComp = this;
        var currentPosition;

        $('.js-room-button').each(function (btn) {
            $(this).on('click', function (ev) {
                currentPosition = $(document).scrollTop();
                thisComp.altHeading = this.dataset.heading;
                thisComp.IBEUrlData.rateCode = this.dataset.ratecode;
                thisComp.IBEUrlData.roomCode = this.dataset.roomcode;
                thisComp.defaultText = document.getElementById('date__start-date').innerHTML;
            });
        });

        this.initAdultChildrenDropdown(0);

        function iosBookingFix() {
            //IOS 8 and 9 hack for booking form when you have todays date selected and start scrolling or click elsewhere it resets for some bizarre reason.
            //This adds a active class again to make it look correct again
            if ($('body').hasClass('ios8') || $('body').hasClass('ios9')) {
                var original = $('.date__start-date').html();
                var result = original.substr(original.indexOf(" ") + 1);
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth(); //January is 0!
                var yyyy = today.getFullYear();
                var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                var month = monthNames[mm];
                today = dd + ' ' + month + ' ' + yyyy;

                setTimeout(function () {
                    if (today === result) {
                        if (!$('.ui-datepicker-today').hasClass("ui-datepicker-manual-current-day")) {
                            $('.ui-datepicker-today').addClass("ui-datepicker-manual-current-day");
                        }
                    }
                    else {
                        $('.ui-datepicker-manual-current-day').removeClass("ui-datepicker-manual-current-day");
                    }
                }, 50);
            }
        }

        $('.room-booking').click(function () {
            iosBookingFix();
        });

        $('#room-booking').scroll(function () {
            iosBookingFix();
        });
    },

    methods: {
        // This function is to unbind the select2 scroll handlering when the select2 menu is open
        // to will allow the user to scroll the main page
        updateSelect2ToAllowWindowScrolling(e) {
            const evt = "scroll.select2";
            $(e.target).parents().off(evt);
            $(window).off(evt);
        },

        initAdultChildrenDropdown(key) {
            var self = this;

            var adultSelectId = "#js-room-" + key + "-adult"

            $(adultSelectId).select2({
                dropdownParent: $(adultSelectId).parents('.room-booking__room-booking'),
                minimumResultsForSearch: -1,
                allowClear: true,
                dropdownCssClass: ""
            }).on('change', event => {
                const value = $("#" + event.target.id).find(':selected')[0].text
                const key = $("#" + event.target.id).attr("data-index");
                this.rooms[key].adult = parseInt(value)
                this.onChange()
            }).on('select2:open', function (e) {
                self.updateSelect2ToAllowWindowScrolling(e);

                setTimeout(() => {
                    const bookingTabs = $(".booking-menu-tabs__content")

                    bookingTabs.each(function () {
                        $(this).addClass("overflow-none")
                    })
                }, 30)
            }).on('select2:close', function (e) {
                const bookingTabs = $(".booking-menu-tabs__content")

                bookingTabs.each(function () {
                    $(this).removeClass("overflow-none")
                })
            });

            const parentAdult = $(adultSelectId).parent();
            if (parentAdult && parentAdult.find("label").length > 0) {
                const labelIdAdult = parentAdult.find("label")[0].id;
                const singleSelectionAdult = parentAdult.find(".select2-selection--single")
                singleSelectionAdult.first().attr("aria-labelledby", labelIdAdult)
            }
            this.setRoomTypeAriaLabel('.booking-table__adults--centered', adultSelectId);

            if (this.defaultAdults) {
                $("#js-room-" + key + "-adult").val(this.defaultAdults).trigger('change')
            }

            var childSelectId = "#js-room-" + key + "-child"

            $(childSelectId).select2({
                dropdownParent: $(childSelectId).parents('.room-booking__room-booking'),
                minimumResultsForSearch: -1,
                allowClear: true,
                dropdownCssClass: "booking-menu-tabs__content"
            }).on('change', event => {
                const value = $("#" + event.target.id).find(':selected')[0].text
                const key = $("#" + event.target.id).attr("data-index");
                this.rooms[key].children = parseInt(value)
                this.onChange()
            }).on('select2:open', function (e) {
                self.updateSelect2ToAllowWindowScrolling(e);

                setTimeout(() => {
                    const bookingTabs = $(".booking-menu-tabs__content")

                    bookingTabs.each(function () {
                        $(this).addClass("overflow-none");
                    })
                }, 30)
            }).on('select2:close', function (e) {
                const bookingTabs = $(".booking-menu-tabs__content")

                bookingTabs.each(function () {
                    $(this).removeClass("overflow-none")
                })
            });

            const parentChild = $(childSelectId).parent()
            if (parentChild.length && parentChild.find("label").length > 0) {
                const labelIdChild = parentChild.find("label")[0].id;
                const singleSelectionChild = parentChild.find(".select2-selection--single")
                singleSelectionChild.first().attr("aria-labelledby", labelIdChild)
            }

            this.setRoomTypeAriaLabel('.booking-table__children--centered', childSelectId);

            if (this.defaultChildren) {
                $("#js-room-" + key + "-child").val(this.defaultChildren).trigger('change')
            }
        },

        onChange: function ($event) {
            $('.room-booking__dropdown-options').removeClass('room-booking__dropdown-options--open');

            $('.room-booking__dropdown-options').attr('aria-hidden', true);
            $('.room-booking__form-group').attr('aria-expanded', false);

            $('.room-booking__filter-btn').removeClass('room-booking__dropdown__open--open');

            this.checkMaxPeople();
        },

        isMaxCapacity: function (element, index, array) {
            // returns true or false
            return element >= this.maxCapacity;
        },

        disableButton: function () {

            if (this.showMaxRoomsInfo == true || this.showMaxPeopleInfo == true) {
                this.disabledButton = true;
            } else {
                this.disabledButton = false
            }
        },

        checkMaxPeople: function () {
            this.totalPeople = [];
            for (var i = 0, len = this.rooms.length; i < len; i++) {
                var roomTotal = this.rooms[i].adult + this.rooms[i].children;
                this.totalPeople.push(roomTotal);
            }

            this.showMaxPeopleInfo = this.totalPeople.some(this.isMaxCapacity);
        },

        updateDate: function (date) {
            this.date = date;
            this.startDate = date[1] ? date[0] : date[2];
            this.endDate = date[1];

            if (date[1] == null) {
                $('#date__end-date').html(this.defaultText);
            }

            this.IBEUrlData.checkInDate = date[0];
            this.IBEUrlData.checkOutDate = date[1];
        },

        sendToIBE: function () {
            var that = this;
            var newWindowRef = window.open();

            that.clearIBEURLError();

            var data = {
                rooms: this.rooms,
                checkInDate: this.IBEUrlData.checkInDate,
                checkOutDate: this.IBEUrlData.checkOutDate,
                promoCode: this.IBEUrlData.promoCode,
                rateCode: this.IBEUrlData.rateCode,
                roomCode: this.IBEUrlData.roomCode,
            }

            this.getRoomBookingURL(data, function (url) {
                if (url) {
                    var gaData = that.getLinker();

                    newWindowRef.location = url + '&' + that.getLinker();
                }
            });
        },

        displayIBEURLError: function () {
            var errorElem = document.querySelector('#IBEUrlError');
            if (errorElem) {
                errorElem.classList.add('show');
                errorElem.setAttribute('aria-hidden', 'false');
            }
        },

        clearIBEURLError: function () {
            var errorElem = document.querySelector('#IBEUrlError');
            if (errorElem) {
                errorElem.classList.remove('show');
                errorElem.setAttribute('aria-hidden', 'true');
            }
        },

        getRoomBookingURL: function (data, callback) {
            var url = "/api/booking-link/room/?language=" + window.preferredCulture;
            var that = this;

            var payload = {
                rooms: data.rooms,
                promoCode: data.promoCode,
                checkInDate: data.checkInDate,
                checkOutDate: data.checkOutDate,
                rateCode: data.rateCode,
                roomCode: data.roomCode,
            };

            axios.post(url, payload, {
                timeout: 4000
            }).then(function (response) {
                if (response && response.status === 200) {
                    that.clearIBEURLError();
                    callback(response.data);
                } else {
                    // throw new Error("IBE: Error getting URL" + response.statusText);
                    console.error("IBE: Error getting URL: " + response.statusText);
                    that.displayIBEURLError();
                }
            }).catch(function (err) {
                if (err.response) {
                    // The request was made and the server responded with a status code that falls out of the range of 2xx
                    // console.log("IBE URL Response Error", err.response.data);
                } else if (err.request) {
                    // The request was made but no response was received
                    // console.log("IBE URL Request Error", err.request);
                } else {
                    // console.log("IBE URL Generic Error", err.message);
                }

                that.displayIBEURLError();
                return false;
            });
        },  

        getLinker: function () {
            var ga = window[window['GoogleAnalyticsObject']];
            if (ga && ga.getAll) {
                return ga.getAll()[0].get('linkerParam');
            }
            return '';
        },

        addRoom: function () {

            if ((this.rooms.length) == this.maxRooms) {
                this.showMaxRoomsInfo = true
            } else {

                // set room with 0 as default
                this.rooms.push({
                    adult: 2,
                    children: 0
                });
                // keep count of rooms
                this.totalRooms = this.totalRooms + 1;
                setTimeout(() => {
                    this.initAdultChildrenDropdown(this.totalRooms - 1);
                }, 10)

            }
        },

        arrowNavigationToggle: function ($event) {
            var currentElem = $event.currentTarget.closest('.room-booking__form-item');

            var elementToToggle = null;

            switch ($event.keyCode) {
                // UP
                case 38:
                    elementToToggle = $(currentElem).prev('.room-booking__form-item');
                    this.navigateToDropdownElement(elementToToggle);
                    $event.preventDefault();
                    break;

                // DOWN
                case 40:
                    elementToToggle = $(currentElem).next('.room-booking__form-item');
                    this.navigateToDropdownElement(elementToToggle);
                    $event.preventDefault();
                    break;

                case 13:
                    $event.currentTarget.click();
                    $($event.currentTarget.closest('.room-booking__form-group')).attr('aria-expanded', false);
                    $($event.currentTarget.closest('.room-booking__dropdown-options')).removeClass('room-booking__dropdown-options--open');
                    $($event.currentTarget.closest('.room-booking__dropdown-options')).attr('aria-hidden', true);
                    $($event.currentTarget.closest('.room-booking__form-group')).find('.room-booking__filter-btn').focus();
                    $event.preventDefault();
                    break;
            }

        },

        navigateToDropdownElement: function (elementToToggle) {
            var activeOptionClass = 'room-booking__radio-item--focus';

            if (elementToToggle.length > 0) {
                elementToToggle.closest('.room-booking__dropdown-options').find('.' + activeOptionClass).removeClass(activeOptionClass);
                elementToToggle.find('label').addClass(activeOptionClass);
                elementToToggle.find('input').focus();
            }
        },

        arrowNavigationInit: function ($event) {
            var options = $event.currentTarget.parentNode.querySelectorAll('.room-booking__dropdown-options .room-booking__form-item');
            var activeOptionClass = 'room-booking__radio-item--focus';

            switch ($event.keyCode) {

                // DOWN
                case 40:
                    options[0].querySelector('label').classList.add(activeOptionClass);
                    options[0].querySelector('input').focus();

                    break;
            }


        },

        toggleOpenFilter: function ($event) {

            $event.currentTarget.classList.toggle('room-booking__dropdown__open--open');
            var isDropdownExpanded = $event.currentTarget.parentNode.getAttribute('aria-expanded');
            if (isDropdownExpanded == "false") {
                $event.currentTarget.parentNode.setAttribute('aria-expanded', 'true');
            } else {
                $event.currentTarget.parentNode.setAttribute('aria-expanded', 'false');

            }

            $event.currentTarget.nextElementSibling.classList.toggle('room-booking__dropdown-options--open');
            var isDropdownHidden = $event.currentTarget.nextElementSibling.getAttribute('aria-hidden');
            $event.currentTarget.nextElementSibling.setAttribute('aria-hidden', !isDropdownHidden);
        },

        removeRoom: function (room, key) {

            if ((this.rooms.length) < this.maxRooms) {
                this.showMaxRoomsInfo = false
            }

            this.rooms.splice(key, 1);

            this.totalRooms = this.totalRooms - 1;

            // recalc people once room removed
            this.checkMaxPeople();

            this.rooms.forEach((room, index) => {
                if (index > 0) {
                    const adultSelectId = "#js-room-" + index + "-adult";
                    const childSelectId = "#js-room-" + index + "-child";

                    $(adultSelectId).val(room.adult).trigger('change')
                    $(childSelectId).val(room.children).trigger('change')
                }
            })
        },
        setRoomTypeAriaLabel: function (individualTypeLabelSelector, select2IdSelector) {
            // Build the dynamic label value based on the room number and individual type 

            var bookingIndividualTypeElem = $(individualTypeLabelSelector);
            if (bookingIndividualTypeElem.length === 0) return false;

            var bookingRoomContainerElem = $(select2IdSelector).parents('.booking-table__row');
            if (bookingRoomContainerElem.length === 0) return false;

            var bookingIndividualTypeText = bookingIndividualTypeElem.text().trim().toLowerCase(); // Adult vs Children
            var bookingRoomNumberPrefix = bookingRoomContainerElem.find('.booking-table__room span').text().trim() + ' ';
            var bookingSelectLabel = bookingRoomNumberPrefix + bookingIndividualTypeText;

            var bookingComboBoxSelectElem = $(select2IdSelector).next('.select2-container').find(".select2-selection--single");
            if (bookingComboBoxSelectElem.length > 0) {
                bookingComboBoxSelectElem.attr('aria-label', bookingSelectLabel);
            }
        },
        togglePromoCodeField(toggleValue) {
            this.isPromoCodeOpen = toggleValue;

            if (this.isPromoCodeOpen) {
                this.$nextTick(function () {
                    if (this.$refs.promoCodeInput) {
                        this.$refs.promoCodeInput.focus();
                    }
                });
            }
        },

        promoCodeClearAndClose() {
            this.togglePromoCodeField(false);
            this.IBEUrlData.promoCode = '';
        },

        onPromoCodeKeyDown: function (e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }
    },
    template: '#roombooking'
});

function getIBEUrl() {

    if (typeof window.pegasusIBEUrl !== 'undefined') {
        return pegasusIBEUrl;
    }
    return 'https://www.reservations-page.com/';
}

function getIBEChainID() {

    if (typeof window.pegasusIBEChainID !== 'undefined') {
        return pegasusIBEChainID + '/';
    }
    return 'C00769/';
}

function getIBELanguage() {

    if (typeof window.pegasusIBELanguage !== 'undefined') {
        return pegasusIBELanguage;
    }
    return '1';
}